import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SINGLE_OFFICE_MODE } from '../../config';
import { MAIN_CONTENT_DATA_WRAPPER_SETTINGS } from '../../globals';
import BtnBack from '../../common/BtnBack/BtnBack';
import InfoPanel from '../../common/InfoPanel/InfoPanel';
import RowHorizontal from '../../common/RowHorizontal/RowHorizontal';
import TitleTop from '../../common/TitleTop/TitleTop';
import TextWrapper from '../../common/TextWrapper/TextWrapper';
import DataWrapper from '../../common/DataWrapper/DataWrapper';
import CategoryDropDown from '../../common/CategoryDropDown/CategoryDropDown';
import BtnService from '../../common/BtnService/BtnService';
import ErrorScreen from '../../common/ErrorScreen/ErrorScreen';
import { StyledBlockWrapper } from '../../common/DataWrapper/styles/StyledBlockWrapper';

import { StyledServicesContent } from './styles/StyledServicesContent';


class ServicesContent extends Component {
  constructor(props) {
    super(props);

    this.renderCategories = this.renderCategories.bind(this);
    this.renderServicesForCategory = this.renderServicesForCategory.bind(this);
    this.renderServicesNoCategories = this.renderServicesNoCategories.bind(this);
    this.renderService = this.renderService.bind(this);
  }

  renderServicesForCategory(i) {
    const { servicesData, officeId } = this.props;

    return(
      <CategoryDropDown
        title={servicesData.data[i].name}
      >
        <div>
        { servicesData.data[i].services.map((row, index) => {
          return (
            <div key={'officeData' + index}>
              <BtnService 
                title={row.name}
                officeId={officeId}
                serviceId={row.id}
                servicesGroups={this.props.servicesData.groups}
              />
            </div>
          );
        })}
        </div>
      </CategoryDropDown>
    );
  }

  renderCategories() {
    const { servicesData } = this.props;
    const length = servicesData.data.length;

    let ret = [];

    for (var i = 1; i < length; i = i + 2) {
      ret.push(
        <div className="row service-content-row"
          key={i}
        >
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderServicesForCategory(i - 1)}
          </div>
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderServicesForCategory(i)}
          </div>
        </div>
      );
    }

    if (length % 2 === 1) {
      ret.push(
        <div className="row service-content-row"
          key={length - 1}
        >
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderServicesForCategory(length - 1)}
          </div>
        </div>
      );
    }

    return ret;
  }

  renderServicesNoCategories() {
    const { servicesData } = this.props;
    const length = servicesData.data.length;

    let ret = [];

    for (var i = 1; i < length; i = i + 2) {
      ret.push(
        <div className="row service-content-row row-equal"
          key={i}
        >
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderService(i - 1)}
          </div>
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderService(i)}
          </div>
        </div>
      );
    }

    if (length % 2 === 1) {
      ret.push(
        <div className="row service-content-row"
          key={length - 1}
        >
          <div className="col col-lg-6 col-md-12 col-sm-12 col-xs-12">
            {this.renderService(length - 1)}
          </div>
        </div>
      );
    }

    return ret;
  }

  renderService(id) {
    const { servicesData, officeId } = this.props;

    return (
      <BtnService 
        title={servicesData.data[id].name}
        officeId={officeId}
        serviceId={servicesData.data[id].id}
        servicesGroups={this.props.servicesData.groups}
      />
    )
  }


  render() {
    const { servicesData, officeData, servicesCommon, previousSteps, btnBackTitle, } = this.props;

    let services;

    if (servicesData.data.length < 1) {
      services = (
        <StyledBlockWrapper
          setMinHeight={true}
          minHeight={200}
        >
          <ErrorScreen 
            title="Nejsou k dispozici žádná data"
          />
        </StyledBlockWrapper>
      );
    }

    else if (servicesData.groups){
      services = ( 
        <div> 
          {this.renderCategories()}
        </div>);
    }
    else {
      services = this.renderServicesNoCategories();
    }

    return (
      <StyledServicesContent>

        { !SINGLE_OFFICE_MODE &&
          <BtnBack 
            text={`ZPĚT NA ${btnBackTitle}`}
            linkTo="/"
          />
        }

        <InfoPanel
          locationData={{
            show: true,
            title: previousSteps.one,
            text1: officeData.data.pub_server_name,
            text2: officeData.data.server_address,
            isLoading: officeData.isLoading,
            status: officeData.status,
          }}
          serviceData={{
            show: false,
          }}
          timeData={{
            show: false,
          }}
        />
      
        <RowHorizontal />

        <TitleTop   
          number={SINGLE_OFFICE_MODE ? 1 : 2}
          title={servicesCommon.title}
        />

        <TextWrapper>
          {<div dangerouslySetInnerHTML={{ __html: servicesCommon.content }}></div>}
        </TextWrapper>

        <DataWrapper
          isLoading={servicesData.isLoading}
          status={servicesData.status}
          minHeight={200}
          isLoadingText="Načítám"
          errorMessage="Nepodařilo se načíst data. Zkuste prosím stránku načíst znovu, nebo opakujte akci později."
          spinnerFat={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.spinnerFat} 
          spinnerSize={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.spinnerSize} 
          textSizeLoading={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.textSizeLoading}
          textSizeError={MAIN_CONTENT_DATA_WRAPPER_SETTINGS.textSizeError}
        >
          { services }
        </DataWrapper>        
        
      </StyledServicesContent>      
    );
  }
}


ServicesContent.propTypes = {
  servicesData: PropTypes.object.isRequired,
  previousSteps: PropTypes.object.isRequired,
  servicesCommon: PropTypes.object.isRequired,
  officeData: PropTypes.object.isRequired,
  officeId: PropTypes.string,
};


export default ServicesContent;



// WEBPACK FOOTER //
// ./src/components/ServicesContent/ServicesContent.js